import DgDimSelect from './src/main.vue'
// 为组件提供 install 安装方法，供按需引入
DgDimSelect.install = function (Vue) {
  Vue.component(DgDimSelect.name, DgDimSelect)
}
export default DgDimSelect

export { DgDimSelect }